document.addEventListener('variant:change', (e) => {
  const variant = e.detail.variant
  if (!variant || !variant.option1) return

  const activeKey = resultKey(variant.option1)

  // MAIN SLIDES
  document.querySelectorAll('.product-main-slide').forEach(slide => {
    const slideKey = resultKey(slide.dataset.setName)
    slide.classList.toggle('hide', slideKey !== activeKey)
  })

  // THUMBNAILS
  document.querySelectorAll('.product__thumb-item').forEach(thumb => {
    const thumbKey = resultKey(thumb.dataset.setName)
    thumb.classList.toggle('hide', thumbKey !== activeKey)
  })

  // Flickity refresh
  const slider = document.querySelector('.product-slideshow')
  if (slider?.flickityInstance) {
    slider.flickityInstance.resize()
    slider.flickityInstance.select(0)
  }
})

function resultKey(value = '') {
  return value
    .toString()
    .trim()
    .toLowerCase()
}
